export default class ShoppingCart {
  constructor() {
    this.localStorageKey = 'gpgroot-shopping-cart';
  }

  updateQuantity(index, quantity) {
    const products = this.getProducts();
    products[index].quantity = ShoppingCart.validateNumber(quantity);
    this.saveProducts(products);

    return products[index].quantity;
  }

  updateVolume(index, volume) {
    const products = this.getProducts();
    products[index].volume = ShoppingCart.validateNumber(volume);
    this.saveProducts(products);
  }

  updateFrequency(index, frequency) {
    const products = this.getProducts();
    products[index].frequency = frequency;
    this.saveProducts(products);
  }

  addProduct(product) {
    /* eslint-disable max-len */
    if (!product || !product.id || !product.title || !product.quantity
      || !product.volume || !product.frequency) {
      return ShoppingCart.createResponse('Het product kan niet aan de winkelwagen worden toegevoegd.', false);
    }
    /* eslint-enable max-len */

    const productToAdd = product;

    productToAdd.quantity = ShoppingCart.validateNumber(productToAdd.quantity);
    // productToAdd.volume = ShoppingCart.validateNumber(productToAdd.volume);

    const products = this.getProducts();

    const indexOfSameProductInShoppingCart = ShoppingCart.getIndexOfProductInProducts(product,
      products);

    if (indexOfSameProductInShoppingCart !== false) {
      products[indexOfSameProductInShoppingCart].quantity += product.quantity;
    } else {
      products.push(productToAdd);
    }

    this.saveProducts(products);
    
    if (!this.storageWorks()) {
      return ShoppingCart.createResponse(
        'De winkelwagen kan niet worden bijgewerkt omdat u hoogst waarschijnlijk gebruikt maakt van een incognito-venster / private-browsing.', false,
      );
    }

    if (indexOfSameProductInShoppingCart !== false) {
      return ShoppingCart.createResponse('Het aantal van het product is met het door u ingevoerde aantal verhoogd.', true, true);
    }

    return ShoppingCart.createResponse('Het product is met succes toegevoegd aan uw winkelwagen');
  }

  removeProductAtIndex(index) {
    const products = this.getProducts();
    products.splice(index, 1);
    this.saveProducts(products);
  }

  hasProducts() {
    return this.getProducts().length > 0;
  }

  getProductsAsJson() {
    const json = ShoppingCart.getStorage().getItem(this.localStorageKey);
    return json;
  }

  getProducts() {
    const json = this.getProductsAsJson();
    let products = json ? JSON.parse(json) : [];

    if (!products) {
      products = [];
      this.saveProducts(products);
    }

    return products;
  }

  saveProducts(products) {
    const json = JSON.stringify(products);
    ShoppingCart.getStorage().setItem(this.localStorageKey, json);

    this.updateMobileInfo();
  }

  clear() {
    ShoppingCart.getStorage().removeItem(this.localStorageKey);
  }

  storageWorks() {
    const products = this.getProducts();
    const result = products && products.length > 0;

    return result;
  }

  static validateNumber(input) {
    let result = parseInt(input, 10);

    if (!ShoppingCart.isInteger(result) || result < 0) {
      result = 1;
    }

    return result;
  }

  static isInteger(value) {
    /* eslint-disable-next-line no-restricted-globals */
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  }

  static getStorage() {
    return window.localStorage;
  }

  static createResponse(message, success = true, updated = false) {
    return {
      message,
      success,
      updated,
    };
  }

  static getIndexOfProductInProducts(product, products) {
    if (!product || !products) {
      return false;
    }

    for (let x = 0; x < products.length; x += 1) {
      const compareTo = products[x];
      const isSameProduct = product.id === compareTo.id
        && product.volume === compareTo.volume
        && product.frequency === compareTo.frequency;

      if (isSameProduct) {
        return x;
      }
    }

    return false;
  }

  updateMobileInfo() {
    const products = this.getProducts();
    const shoppingCartInfo = document.querySelector('.shopping-cart-info.fixed-bottom-bar-mobile');
    const productCountEl = document.querySelector('.shopping-cart-info .product-count');

    shoppingCartInfo.classList.toggle('hidden', !products || products.length === 0);

    if (products.length === 1) {
      productCountEl.innerHTML = ` (${products.length} item)`;
    } else {
      productCountEl.innerHTML = ` (${products.length} items)`;
    }
  }
}
